import React from 'react';
import { profileData } from '../../data/profileData';
import { Card, SectionHeader, Tag } from '../ui';

/** Every skill category at a glance, one card per category. */
const TechnicalSkills: React.FC = () => (
  <div className="expertise__block">
    <SectionHeader id="skills-heading" title="Technical Skills" level={3} />
    <ul className="skills-grid" aria-labelledby="skills-heading">
      {Object.entries(profileData.skills.technical).map(([category, skills]) => (
        <Card as="li" key={category} className="skills-card">
          <h4 className="skills-card__title">{category}</h4>
          <ul className="skills-card__tags" aria-label={`${category} skills`}>
            {skills.map((skill) => (
              <li key={skill}>
                <Tag>{skill}</Tag>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </ul>
  </div>
);

export default TechnicalSkills;
